import { useEffect } from "react";
import { syncSubscribedShows } from "../lib/web-push";

/**
 * Keeps the server's push_subscription record in sync with the user's local
 * show-alert preferences. Runs silently on every page. If the user has never
 * granted notification permission this is a no-op.
 */
const AlertsManager = () => {
  useEffect(() => {
    let cancelled = false;
    const sync = () => {
      if (cancelled) return;
      syncSubscribedShows().catch(() => {});
    };
    sync();
    const onStorage = (e) => {
      if (e.key === "gfn_show_alerts") sync();
    };
    window.addEventListener("storage", onStorage);
    return () => {
      cancelled = true;
      window.removeEventListener("storage", onStorage);
    };
  }, []);
  return null;
};

export default AlertsManager;
